import script from "./EmptyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyView.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyView.vue?vue&type=style&index=0&id=3ee9df30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ee9df30"]])

export default __exports__